export default {
  common: {
    cancel: "Cancel",
    apply: "Apply",
    ok: "OK",
    height: "Height",
    width: "Width",
    doubleShelf: "Double shelf",
    floor: "Boden", ///
    shelfLoad: "shelf load",
    layer: "Layer",
    depth: "Depth",
    shelfHeight: "shelf height:",
    price: "VAT excluded plus shipping",
    addToCart: "In the basket",
    offerRequest: "Request a quote",
    settingsEdit: "Choose basic properties",
    settingsDialogtitle: "Basic Properties",
  },
  fieldOptionsDialog: {
    layer: "Layer",
    sidePanelLeft: "Side panel left",
    sidePanelRight: "Side panel right",
    securing: "Securing",
    bullbarLeft: "Ram protection left",
    bullbarRight: "Ram protection right",
    fieldOptions: "Field options",
  },
  frontView2d: {
    hint: "Hint",
    exceededWeight: "Maximum field load exceeded.",
  },
  layerOptionsDialog: {
    layerOptions: "Layer options",
  },
  shareEmail: {
    subject: "Check out my configuration!",
    body: "Click on the following Link to open my configuration: ",
  },
  loadConfiguration: {
    loadConfiguration: "Load Configuration",
    loading: "load...",
    existingCodeText:
      "You have already configured a product? Please enter your personal configuration code here to load it:",
    configurationCode: "Configuration code",
  },
  pdfDownload: {
    yourConfiguration: "Your Configuration",
    readyToDownloadText: "Your configuration was saved successfully and you can download the PDF now:",
    downloadNow: "Download now",
  },
  saveConfiguration: {
    saveConfiguration: "Save configuration",
    saveSuccessfully: "Konfiguration erfolgreich gespeichert.",
    loadWithCodeText: "With the following code you can access your configuration at any time:",
  },
  sendEmail: {
    sendConfiguration: "Send configuration by e-mail",
    saveSuccessfully: "Configuration successfully saved! Your configuration can now be sent by e-mail.",
    softwareNote: "It is sent using your existing e-mail software.",
    sendEmail: "Send email ",
  },
  settingsArtus: {
    distancePieces: "Spacers",
    noFloor: "Without bottom",
    replaceAllBottoms: "The selection replaces all bottoms in the configuration.",
    palletBays: "Pallet bays: {{palletSum}}",
  },
  settingsBertWarehouse: {
    color: "Color",
    usableFromBothSides: "Usable from both sides",
    frameHeight2000Information:
      "Choose 6 shelves and a depth of 300 mm or 600 mm to optimize the shelf for files",
    frameHeight2325Information:
      "Choose 7 shelves and a depth of 300 mm or 600 mm to optimize the shelf for files",
  },
  settingsBertArchive: {
    frameHeight2075Information:
      "Choose 5 shelves and a depth of 300 mm or 600 mm to optimize the shelf for files",
    frameHeight2500Information:
      "Choose 6 shelves and a depth of 300 mm or 600 mm to optimize the shelf for files",
  },

  visualization2d: {
    topView: "Top view",
    frontView: "Front view",
  },
  header: {
    savingFailed: "Could not save the configuration.",
  },
  receiveOfferForm: {
    label: "Request a quote",
    data: "Contact data",
    email: "E-Mail-Address",
    name: "Name",
    company: "Company",
    phonenumber: "Phone number",
    zip: "Zip",
    city: "City",
    street: "Street",
    country: "Country",
    annotation: "Annotation",
    errors: {
      required: "Required",
      invalidEmail: "E-mail is invalid",
    },
    checkInputsInForm: "Please check the form inputs below",
    sentOk: "Request was successfully sent.",
    sentError: "Error sending the request.",
    sendButton: "Request a quote",
  },
};
